import {useRegionConfig} from '@frontend/hooks/useRegionConfig'
import clsx from 'clsx'

interface FooterContactsProps {
    className?: string
}

// Блок с контактами для футера.
export function FooterContacts(props: FooterContactsProps) {

    const {
        className,
    } = props

    const regionConfig = useRegionConfig()

    // Конкретно тут не стоит в <ul> - <li> оборачивать.
    return (
        <div
            className={clsx(
                'footer-contacts d-flex',
                'flex-column gap-3 align-items-center justify-content-start',
                'flex-lg-row gap-lg-4',
                className
            )}
        >
            <a
                href={'tel:' + regionConfig.contacts.phone.replace(/[^0-9+]/g, '')}
                className="contact-phone fs-5"
            >
                {regionConfig.contacts.phone}
            </a>
            <a
                href={'mailto:' + regionConfig.contacts.email}
                className="contact-email link-blue text-decoration-underline-hover-none"
            >
                {regionConfig.contacts.email}
            </a>
        </div>
    )
}
